import {ref} from 'vue';
import breakpoints from '../../../variables/js/breakpoints';

type Breakpoint = number | keyof typeof breakpoints;

export {type Breakpoint};

export function useIsMobile(breakpoint: Breakpoint) {
  window.addEventListener('breakpointChange', () => breakpointChangeHandler(breakpoint));
  const isMobile = ref(false);

  function breakpointChangeHandler(breakpoint: Breakpoint) {
    if (typeof breakpoint === 'string') {
      isMobile.value = window.innerWidth < breakpoints[breakpoint];
    }
    else if (typeof breakpoint === 'number') {
      isMobile.value = window.innerWidth < breakpoint;
    }
  }

  breakpointChangeHandler(breakpoint);

  return {
    isMobile
  }
}





